import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { profilesAPI, generalAPI } from '../utils/api';
import toast from 'react-hot-toast';
import './Professionals.css';

export default function Professionals() {
  const [profiles, setProfiles] = useState([]);
  const [categories, setCategories] = useState([]);
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filters, setFilters] = useState({
    search: '', sport_category: '', job_role: '', location: ''
  });

  useEffect(() => {
    Promise.all([generalAPI.getCategories(), generalAPI.getRoles()])
      .then(([cats, rls]) => {
        setCategories(cats.data.data || []);
        setRoles(rls.data.data || []);
      });
  }, []);

  useEffect(() => {
    fetchProfiles();
  }, [page, filters]);

  const fetchProfiles = async () => {
    setLoading(true);
    try {
      const params = { page, limit: 12, ...filters };
      const res = await profilesAPI.getAll(params);
      setProfiles(res.data.profiles || []);
      setTotalPages(res.data.pages || 1);
    } catch {
      toast.error('فشل تحميل الملفات الشخصية');
    } finally {
      setLoading(false);
    }
  };

  const handleFilterChange = e => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
    setPage(1);
  };

  return (
    <div className="professionals-page">
      <div className="page-hero">
        <div className="hero-content">
          <h1>المحترفون الرياضيون</h1>
          <p>اكتشف أفضل الكفاءات والمتخصصين في القطاع الرياضي</p>
        </div>
      </div>

      <div className="pros-container">
        <div className="pros-filters">
          <input type="text" name="search" className="form-input filter-search"
            placeholder="🔍 ابحث بالاسم أو المهارة..."
            value={filters.search} onChange={handleFilterChange} />
          <select name="sport_category" className="form-input" value={filters.sport_category} onChange={handleFilterChange}>
            <option value="">جميع الرياضات</option>
            {categories.map(c => <option key={c.id} value={c.id}>{c.name_ar || c.name}</option>)}
          </select>
          <select name="job_role" className="form-input" value={filters.job_role} onChange={handleFilterChange}>
            <option value="">جميع التخصصات</option>
            {roles.map(r => <option key={r.id} value={r.id}>{r.name_ar || r.name}</option>)}
          </select>
          <input type="text" name="location" className="form-input"
            placeholder="الموقع"
            value={filters.location} onChange={handleFilterChange} />
        </div>

        {loading ? (
          <div className="loading-grid">
            {[...Array(6)].map((_, i) => <div key={i} className="skeleton-card" />)}
          </div>
        ) : profiles.length === 0 ? (
          <div className="empty-state">
            <span className="empty-icon">👤</span>
            <h3>لا يوجد محترفون مطابقون</h3>
            <p>جرّب تغيير معايير البحث</p>
          </div>
        ) : (
          <div className="pros-grid">
            {profiles.map(profile => (
              <Link to={`/profile/${profile.uuid}`} key={profile.uuid} className="pro-card">
                <div className="pro-card-header">
                  {profile.avatar ? (
                    <img src={`${process.env.REACT_APP_API_URL}/uploads/${profile.avatar}`}
                      alt={profile.full_name} className="pro-avatar" />
                  ) : (
                    <div className="pro-avatar-placeholder">
                      {profile.full_name?.[0]}
                    </div>
                  )}
                  <div className="pro-info">
                    <h3>{profile.full_name}</h3>
                    <p className="pro-role">{profile.job_title || 'محترف رياضي'}</p>
                    {profile.location && <p className="pro-location">📍 {profile.location}</p>}
                  </div>
                </div>
                {profile.bio && <p className="pro-bio">{profile.bio.slice(0, 120)}...</p>}
                <div className="pro-tags">
                  {profile.sport_category_name && (
                    <span className="badge badge-outline">{profile.sport_category_name}</span>
                  )}
                  {profile.years_of_experience && (
                    <span className="badge badge-secondary">{profile.years_of_experience} سنوات خبرة</span>
                  )}
                </div>
                <div className="pro-card-footer">
                  <span className="pro-stats">⭐ {profile.avg_rating?.toFixed(1) || '—'}</span>
                  <span className="view-profile-btn">عرض الملف ←</span>
                </div>
              </Link>
            ))}
          </div>
        )}

        {totalPages > 1 && (
          <div className="pagination">
            <button className="btn btn-outline" onClick={() => setPage(p => p - 1)} disabled={page === 1}>
              السابق
            </button>
            <span className="page-info">{page} / {totalPages}</span>
            <button className="btn btn-outline" onClick={() => setPage(p => p + 1)} disabled={page === totalPages}>
              التالي
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
